// Descrição: Alerta exibido no sidebar para usuários que não finalizaram o cadastro

import * as React from "react";
import Box from "@mui/material/Box";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import { useNavigate } from "react-router-dom";

const cardPalettes = {
  dark: {
    bg: "rgba(233, 245, 254, 0.08)",
    border: "1.5px solid rgba(233, 245, 254, 0.18)",
    icon: "#a986ff",
    title: "#ffffff",
    text: "#9fb2c2",
    buttonBg: "#8142fc",
    buttonHover: "#6f32e6",
    buttonText: "#ffffff",
    focus: "#a986ff",
  },
  light: {
    bg: "#ffffff",
    border: "1.5px solid rgba(67, 88, 108, 0.30)",
    icon: "#8142fc",
    title: "#162536",
    text: "#32475a",
    buttonBg: "#8142fc",
    buttonHover: "#6f32e6",
    buttonText: "#ffffff",
    focus: "#8142fc",
  },
};

export default function CardAlert({ scale = 1, sidebarDark = true }) {
  const navigate = useNavigate();
  const colors = sidebarDark ? cardPalettes.dark : cardPalettes.light;

  const handleClick = () => {
    navigate("/perfil");
  };

  return (
    <Box
      data-name="Registration Alert"
      sx={{
        backgroundColor: colors.bg,
        border: colors.border,
        borderRadius: "6px",
        boxSizing: "border-box",
        color: colors.title,
        flexShrink: 0,
        fontFamily: "'Poppins', 'Inter', 'Roboto', Helvetica, Arial, sans-serif",
        minHeight: `${168 * scale}px`,
        p: `${14 * scale}px`,
        width: "var(--sidebar-item-width, 277px)",
      }}
    >
      <Box sx={{ alignItems: "center", display: "flex", gap: `${8 * scale}px`, mb: `${8 * scale}px` }}>
        <AutoAwesomeRoundedIcon sx={{ color: colors.icon, fontSize: `${20 * scale}px` }} />
        <Box
          sx={{
            color: colors.title,
            fontSize: `${16 * scale}px`,
            fontWeight: 600,
            lineHeight: `${22 * scale}px`,
          }}
        >
          Finalize seu cadastro
        </Box>
      </Box>
      <Box
        sx={{
          color: colors.text,
          fontSize: `${14 * scale}px`,
          lineHeight: `${20 * scale}px`,
          mb: `${12 * scale}px`,
        }}
      >
        Conclua seu cadastro para liberar todos os recursos da sua conta.
      </Box>
      <Box
        component="button"
        type="button"
        onClick={handleClick}
        sx={{
          backgroundColor: colors.buttonBg,
          border: 0,
          borderRadius: "8px",
          color: colors.buttonText,
          cursor: "pointer",
          fontFamily: "inherit",
          fontSize: `${13.5 * scale}px`,
          fontWeight: 600,
          lineHeight: `${18 * scale}px`,
          minHeight: `${34 * scale}px`,
          px: `${10 * scale}px`,
          transition: "background-color 140ms ease",
          width: "100%",
          "&:hover": {
            backgroundColor: colors.buttonHover,
          },
          "&:focus-visible": {
            outline: `2px solid ${colors.focus}`,
            outlineOffset: 2,
          },
        }}
      >
        Finalizar cadastro
      </Box>
    </Box>
  );
}
